module.exports = __webpack_public_path__ + "media/images/i-f7a7ba2270841f4ceb470c301c1829f3.svg";